<template>
  <Adminlte>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="box box-primary center-block">
          <div class="box-header with-border">
            <h3 class="box-title">Editar Notícia</h3>
          </div>
          <NewsForm :news="news" :errors="errors" :onSubmit="onSubmit"></NewsForm>
        </div>
      </div>
    </div>
  </Adminlte>
</template>
<script>
import Adminlte from '@/components/template/Adminlte'
import NewsClient from '@/services/resource_client/news'
import NewsForm from '@/pages/news/NewsForm'

export default {
  name: 'EditNews',
  components: { Adminlte, NewsForm },
  data: function () {
    return {
      news: {},
      errors: {}
    }
  },
  props: ['id'],
  methods: {
    onSubmit () {
      NewsClient.put(this.news)
      .then(r => { this.$router.push({ name: 'NewsHome' }) })
      .catch(e => { this.errors = e.response.data.errors })
    }
  },
  created () {
    NewsClient.get(this.id)
    .then(r => {
      this.news = r.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// EditNews.vue?dc865498